import { render, staticRenderFns } from "./ModalContractDetail.vue?vue&type=template&id=11b51dcc&"
import script from "./ModalContractDetail.vue?vue&type=script&lang=ts&"
export * from "./ModalContractDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports